import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import { Amplify } from 'aws-amplify';
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import config from "./config";
import "./stylesheets/index.css";

Amplify.configure({
  Auth: {
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    region: config.cognito.REGION,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    mandatorySignIn: true,
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
    }
  },
  API: {
    REST: {
      'echo-dev': {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
      'authdiag-dev': {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
    },
  }
});

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();
